export const LATEST_API = 'APP/Home/LatestPosts.json';
export const POPULAR_API = 'APP/Home/PopularPosts.json';
export const POST_DETAIL_API = '/api/v1/counts';
export const USERS_API = '/api/v1/web/users';
export const BOOKS_FEED_API = 'APP/Home/Books.json';
export const LANDSCAPE_API = 'APP/Home/Landscapes.json';
export const PORTRAIT_API = 'APP/Home/Portraits.json';
export const TRENDING_HOT_API = 'APP/Home/TrendingPosts.json';
export const USER_BY_IDS_API = '/api/v1/web/users/getbyIds?ids=';
export const USER_COUNTER_API = '/api/v1/user/counter';
export const POST_BY_IDS_API = '/api/v1/web/posts/ids?ids=';
export const BOOKS_BY_IDS_API = '/api/v1/web/books';
export const USER_POSTS_API = '/api/v1/web/user/actions/post';
export const REACTIONS_API = '/api/v1/web/reactions';
export const COINS_API = '/api/v1/user/score-and-coins';
export const CLANS_LIST_API = 'APP/Home/Clans.json';
export const CLANS_DETAILS_API = '/api/v1/web/clan/details';
export const CHAMPS_API = 'APP/Champs';
export const CONTEST_API = 'APP/Contests';
export const USER_BY_HANDLENAME_API = '/api/v1/web/search/user?exact=true';
export const CONTEST_ENTRIES_API = '/api/v1/web/contest';
export const CATEGORIES_FILTER_API = '/api/v1/web/contest';
export const WORKS_BY_USERID_API = '/api/v1/web/user/actions/post?userId=';
export const CONTEST_RESULT_ANNOUNCED_API = 'APP/ContestResults';
export const CLANS_CHAMP_API = 'APP/Champs/clans.json';
export const CDN_HOME_QUEST = '/APP/Home/MicroContests.json';
export const CDN_HOME_CLUBS = '/APP/Home/Clubs.json';
export const USER_CONTEST_API = '/api/v1/web/contest/entries?page=&count=&contest_type=CONTEST&user_id=';
export const USER_QUEST_API = '/api/v1/web/contest/entries?page=&count=&contest_type=MICRO_CONTEST&user_id=';
export const SEND_EMAIL = 'api/v1/web/send/email';
export const ACHIEVEMENT_BY_USERID_API = 'api/v1/web/user/actions/achievement?userId=';
export const CDN_TOP_POSTS = 'APP/Home/TopPosts.json';
export const CDN_ALL_CLUBS_API = '/APP/Global/Clubs.json';
export const CLUBS_DETAIL_API = '/api/v1/web/club/users';
export const QUEST_LISTING_API = 'api/v1/web/contests?contest_type=';
export const QUEST_BY_ID = '/api/v1/web/contest/ids?contest_type=MICRO_CONTEST&ids=';
export const QUEST_BY_CODE = '/api/v1/web/contest/ids?contest_code=';
export const CONTEST_BY_ID = '/api/v1/web/contest/ids?contest_type=CONTEST&ids=';
export const CLUBS_BY_ID = 'api/v1/web/user/clubs?userId=';
export const CDN_PRIZES_API = 'APP/Home/Prizes.json';
export const PRIZES_API = '/api/v1/web/rewards?reward_type=PRIZE';
export const CLAN_DETAIL_API = '/api/v1/web/clan/details?clan_id=';
